// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import vueResource from 'vue-resource';
import BootstrapVue from 'bootstrap-vue';
import App from './App'
import router from './router'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import Multiselect from 'vue-multiselect'
import VeeValidate from 'vee-validate';

Vue.use(vueResource);
Vue.use(BootstrapVue);
Vue.component(Multiselect);
Vue.use(VeeValidate);

Vue.config.productionTip = false

if (process.env.NODE_ENV == "development")
  Vue.http.options.root = "http://dev.netherlandish-woodcuts.nl/sprocserv/api/Sproc/12345";
else
  Vue.http.options.root = "https://netherlandish-woodcuts.nl/api/api/Sproc/12345";

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth)
  {
	// Authenticatie nodig

	var auth = Vue.http.headers.common['Authorization'];
	if (auth)
	{
	  // Ingelogd
	  next();
	} else {
	  // Nog niet ingelogd
	  // zijn er authenticatiegegevens opgeslagen?
	  var lsUser = JSON.parse(window.localStorage.getItem('authUser'));
	  if (!lsUser) // Misschien in session storage dan?
		lsUser = JSON.parse(window.sessionStorage.getItem('authUser'));
	  if (lsUser) 
	  {
		var credentials = {username : lsUser.username, password : lsUser.password };
		Vue.http.post('pLoginUser', credentials).then(function(response) {
		  if (response.data[0].Token != null && response.data[0].Token != "") 
		  {
			// Inloggen gelukt => door naar gevraagde scherm
			Vue.http.headers.common['Authorization'] = 'Basic ' + btoa(credentials.username + ":" + credentials.password); 
			next();
		  } else
		  {
			// Geen inloggegevens aanwezig of inloggen mislukt => naar loginscherm
			next({ name: "login", params: { returnpath: to.path } });
		  }
		});
	  }
	  else
	  {
		// Geen inloggegevens aanwezig of inloggen mislukt => naar loginscherm
		next({ name: "login", params: { returnpath: to.path } });
	  }
	}
  }
  else {
	// Geen authenicatie nodig
	next();
  }
});


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js